























































































































































































import { computed, onBeforeMount, ref } from "@vue/composition-api";
import Vue from "vue";
import _ from "lodash";
import formatDate from "../../../helpers/formatDate";
import formatScheduleDate from "../../../helpers/formatScheduleDate";
import formatCurrency from "../../../helpers/formatCurrency";
import AirLine from "../../../components/AirLine";
import { filterFriendlyMessage } from "../../../helpers/filterFriendlyMessage";
import formatDiscountMessage from "../../../helpers/formatDiscountMessage";

const generateGraphLabels = function(labels) {
  const dateLabels = [];
  labels.forEach(element => {
    const label = `${
      element.hours > 12
        ? element.hours - 12 + ":00" + "pm"
        : element.hours + ":00" + "am"
    }`;
    dateLabels.push(label);
  });
  return dateLabels;
};

export default Vue.extend({
  name: "CampaignsView",
  components: {
    AirLine
  },
  setup(props, context: any): any {
    const store = computed(() => context.root.$store.state.store);
    const campaign = computed(
      () => context.root.$store.state.campaigns.campaign
    );
    const campaignReport = computed(
      () => context.root.$store.state.campaigns.campaignReport
    );
    const metrics = ref([]);
    const labels = ref([]);
    const dataOne = ref([]);
    const dataTwo = ref([]);
    const selectedDiscountCodeOption = ref("disable");
    const newDiscountConfiguration = ref({
      percentageDiscount: "",
      fixedDiscount: "",
      purchaseQuantity: "",
      minimumPurchaseAmount: "",
      freeShipping: "",
      validDuration: "604800s"
    });
    const discountConfiguration = ref(null);
    const existingDiscountCode = ref("");
    const minimumPurchaseAmount = ref("");
    const freeShipping = ref("");
    const purchaseQuantity = ref("");
    const discountValueType = ref("percentage");
    const discountMinimumRequirements = ref("none");
    function getCampaign() {
      const campaignId = context.root.$route.params.campaignId;
      context.root.$store
        .dispatch("campaigns/getCampaign", { campaignId })
        .then(res => {
          if (res.discount) {
            if (res.discount.newDiscountConfiguration) {
              // @ts-ignore
              if (res.discount.newDiscountConfiguration.freeShipping) {
                freeShipping.value =
                  // @ts-ignore
                  res.discount.newDiscountConfiguration.freeShipping.includeCountryIds[0];
              }
              // @ts-ignore
              if (res.discount.newDiscountConfiguration.minimumPurchaseAmount) {
                minimumPurchaseAmount.value =
                  // @ts-ignore
                  res.discount.newDiscountConfiguration.minimumPurchaseAmount.units;
              }
              // @ts-ignore
              if (
                res.discount.newDiscountConfiguration.minimumPurchaseQuantity
              ) {
                purchaseQuantity.value = JSON.stringify(
                  // @ts-ignore
                  res.discount.newDiscountConfiguration.minimumPurchaseQuantity
                );
              }

              selectedDiscountCodeOption.value = "new";
              newDiscountConfiguration.value.percentageDiscount = res.discount // @ts-ignore
                .newDiscountConfiguration.percentageDiscount
                ? JSON.stringify(
                    // @ts-ignore
                    res.discount.newDiscountConfiguration.percentageDiscount
                  )
                : "";
              // @ts-ignore
              newDiscountConfiguration.value.freeShipping = freeShipping;

              (newDiscountConfiguration.value.fixedDiscount = res.discount // @ts-ignore
                .newDiscountConfiguration.fixedDiscount
                ? // @ts-ignore
                  res.discount.newDiscountConfiguration.fixedDiscount.units
                : ""),
                // @ts-ignore
                (newDiscountConfiguration.value.minimumPurchaseAmount = minimumPurchaseAmount);
              // @ts-ignore
              newDiscountConfiguration.value.purchaseQuantity = purchaseQuantity;

              newDiscountConfiguration.value.validDuration = res.discount // @ts-ignore
                .newDiscountConfiguration.validDuration
                ? // @ts-ignore
                  res.discount.newDiscountConfiguration.validDuration
                : "604800s";

              if (newDiscountConfiguration.value.percentageDiscount) {
                discountValueType.value = "percentage";
              } else if (newDiscountConfiguration.value.freeShipping) {
                discountValueType.value = "freeShipping";
              } else if (newDiscountConfiguration.value.fixedDiscount) {
                discountValueType.value = "fixedValue";
              }

              if (newDiscountConfiguration.value.minimumPurchaseAmount) {
                discountMinimumRequirements.value = "purchaseAmount";
              } else if (newDiscountConfiguration.value.purchaseQuantity) {
                discountMinimumRequirements.value = "quantityItems";
              } else {
                discountMinimumRequirements.value = "none";
              }
              // @ts-ignore
            } else if (res.discount.existingDiscountCode) {
              selectedDiscountCodeOption.value = "existing";
              // @ts-ignore
              existingDiscountCode.value = res.discount.existingDiscountCode;
            }
          } else {
            selectedDiscountCodeOption.value = "disable";
          }
          discountConfiguration.value = {
            discountValueType: discountValueType.value,
            discountMinimumRequirements: discountMinimumRequirements.value,
            selectedDiscountCodeOption: selectedDiscountCodeOption.value
          };
        });
      context.root.$store
        .dispatch("campaigns/getCampaignReport", {
          campaignId
        })
        .then(res => {
          dataOne.value = res.series[0].data;
          dataTwo.value = res.series[1].data;
          labels.value = generateGraphLabels(res.labels);
          res.metrics.forEach(el => {
            switch (el.type) {
              case "MESSAGE_COUNT":
                metrics.value.push({
                  value: el.value,
                  label: "Sent",
                  icon: "$vuetify.icons.send",
                  order: 4
                });
                break;
              case "COST":
                metrics.value.push({
                  value: `${formatCurrency(
                    el.value.toFixed(2),
                    store.value.primaryLocale + "-" + store.value.countryCode,
                    store.value.primaryCurrencyCode
                  )}`,
                  label: "Cost",
                  icon: "$vuetify.icons.trenddown",
                  order: 2
                });
                break;
              case "ORDER_COUNT":
                metrics.value.push({
                  value: el.value,
                  label: "Orders",
                  icon: "$vuetify.icons.basketsimple",
                  order: 5
                });
                break;
              case "REVENUE":
                metrics.value.push({
                  value: `${formatCurrency(
                    el.value.toFixed(2),
                    store.value.primaryLocale + "-" + store.value.countryCode,
                    store.value.primaryCurrencyCode
                  )}`,
                  label: "Revenue",
                  icon: "$vuetify.icons.trendup",
                  order: 1
                });
                break;
              case "ROI":
                metrics.value.push({
                  value: `${Math.round(el.value * 100)}%`,
                  label: "ROI",
                  icon: "$vuetify.icons.percentagegrey",
                  order: 3
                });
                break;
              case "UNSUBSCRIBE_COUNT":
                metrics.value.push({
                  value: el.value,
                  label: "Unsubscribes",
                  icon: "$vuetify.icons.person",
                  order: 6
                });
                break;
              case "UNIQUE_CLICK_COUNT":
                metrics.value.push({
                  value: el.value,
                  label: "Unique Clicks",
                  icon: "$vuetify.icons.group",
                  order: 8
                });
                break;
              case "CLICK_COUNT":
                metrics.value.push({
                  value: el.value,
                  label: "Total Clicks",
                  icon: "$vuetify.icons.group",
                  order: 7
                });
                break;
              case "CLICK_THROUGH_RATE":
                metrics.value.push({
                  value: `${Math.round(el.value * 100)}%`,
                  label: "Click Through Rate",
                  icon: "$vuetify.icons.group",
                  order: 9
                });
                break;
            }
          });

          metrics.value = _.orderBy(metrics.value, "order", "asc");
        });
    }

    function refreshCampaign() {
      context.root.$mixpanel.track("Click", {
        Parent: "Campaigns",
        Action: "Refresh Campaign"
      });
      metrics.value = [];
      labels.value = [];
      dataOne.value = [];
      dataTwo.value = [];
      getCampaign();
    }

    onBeforeMount(() => {
      context.root.$mixpanel.track("Page Load", { Page: "Campaign View" });
      getCampaign();
    });

    function handleDuplicateCampaign() {
      context.root.$router.push(`./draft`);
    }

    function statusColor(status) {
      let color = "";
      switch (status) {
        case "CANCELLED":
          color = "warning";
          break;
        case "SENDING":
          color = "info";
          break;
        case "SENT":
          color = "success";
          break;
        case "DRAFT":
          color = "lightgray";
          break;
      }
      return color;
    }

    const loading = computed(() => context.root.$store.state.loading);

    return {
      handleDuplicateCampaign,
      loading,
      refreshCampaign,
      campaign,
      campaignReport,
      metrics,
      formatDate,
      formatScheduleDate,
      store,
      statusColor,
      labels,
      dataOne,
      dataTwo,
      discountConfiguration,
      filterFriendlyMessage,
      formatDiscountMessage
    };
  }
});
